module.exports = __webpack_public_path__ + "static/media/NORTHRIDGE ByLaws.8008ce13.pdf";